import XButton from "./XButton";

/**
 * 
 * @typedef {import("./XDiv").xdivparams} xdivparams
 * @typedef {import("./XTooltip").xtooltipparams} xtooltipparams
 * @typedef {import("./XButton").xbuttonparams} xbuttonparams
 * 
 * @typedef {Object} xiconbuttonparams
 * @property {Number} size
 * 
 * @param {xiconbuttonparams & xbuttonparams & xdivparams & xtooltipparams} param0 
 */
function XIconButton({style, size, ...others}){
  return (
    <XButton {...others} round={50} 
      lockWidth={size} lockHeight={size}
      style={{
        boxSizing: "unset",
        ...style,
      }} />
  );
}

export default XIconButton;